import { ApiRequest, BaseResource, putItem, postItem, deleteItem } from "utils/ApiUtils"
import { buildReference } from "./SchemaUtils"
import buildQuery from 'odata-query';
import ODataUtil from './ODataUtil'
import { ProjectIRConfiguration } from "classes";

const project_configuration_endpoint = "/IrConfig"
const testfieldforms_configuration_endpoint = "/TestFieldForms"
const checklist_configuration_endpoint = "/LuChecklistForm"

class ProjectConfiguration extends BaseResource {
  constructor(args, attr = ProjectConfiguration.attributes) {
    super(args, attr)
  }

  static columns = [
    { title: "Configuration", field: "label" },
    { title: "Level", field: "level" },
    { title: "Values", field: "value" },
    { title: "name", field: "name" },
  ]

  static columnsAdditionalFields = [
    { title: "fieldId", field: "fieldId" },
    { title: "Section", field: "tableName" },
    { title: "Field Name", field: "fieldName" },
    { title: "Show", field: "show" },
    { title: "Required", field: "required" },
  ]

  static columnsReportSettingsFields = [
    { title: "Report Tempate ID", field: "reportTemplateId" },
    { title: "reportTemplateName", field: "reportTemplateName" },
    { title: "stateId", field: "stateId" },
    { title: "weatherStationId", field: "weatherStationId" },
  ]

  static columnsTestFieldFormFields = [
    { title: "Form ID", field: "FormId", hidden: true },
    { title: "Form UID", field: "FormUid", hidden: true },
    { title: "Description", field: "Description" },
    { title: "Test Type", field: "TestType" },
    { title: "Active", field: "IsActive", type: "boolean" },
  ]

  static columnsChecklistFields = [
    { title: "Form ID", field: "FormId", hidden: true },
    { title: "Checklist ID", field: "ChecklistFormId", hidden: true },
    { title: "Description", field: "Description" },
    { title: "FileName", field: "FriendlyFileName" },
    { title: "Date Uploaded", field: "DateUploaded", type: "date" },
    { title: "Active", field: "IsActive", type: "boolean" },
    { title: "URL", field: "URL", hidden: true },
  ]

  static attributes = ProjectConfiguration.columns.map(r => r.field)
  static attributesAdditionalFields = ProjectConfiguration.columnsAdditionalFields.map(r => r.field)
  static attributesReportSettingsFields = ProjectConfiguration.columnsReportSettingsFields.map(r => r.field)
  static attributesFieldFormFields = ProjectConfiguration.columnsTestFieldFormFields.map(r => r.field)
  static attributesChecklistFields = ProjectConfiguration.columnsChecklistFields.map(r => r.field)
  static expand = []
}

function convert_section_settings_to_table_schema({ data }) {
  data = data.map(r => {
    const setting = new ProjectIRConfiguration(r)
    r.value === true ? setting.value = 'Show' : setting.value = 'Hide'
    return setting
  })
  const count = data.length
  return {
    data, count
  }
}

function isSection(section, { data }) {

  const result = data.find(({ label }) => label.toLowerCase() === section.toLowerCase())
  if (typeof result !== 'undefined') {
    return result.value;
  }
  return false

}


function convert_additional_settings_to_table_schema({ data }, sectionsSettings) {

  let records = 0;

  data = data.map(r => {
    if (isSection(r.tableName, sectionsSettings)) {
      records++;
      const setting = new ProjectConfiguration(r, ProjectConfiguration.attributesAdditionalFields)
      return setting
    }
  })

  data = data.filter(function( element ) {
    return element !== undefined;
 });

  const count = records

  return {
    data, count
  }
}

function convert_report_settings_to_table_schema({ data }) {
  data = data.map(r => {
    const setting = new ProjectConfiguration(r, ProjectConfiguration.attributesReportSettingsFields)
    return setting
  })
  const count = data.length
  return {
    data, count
  }
}

function convert_fieldform_settings_to_table_schema({ "value": items, "@odata.count": count }) {
  const data = items.map(r => {
    const setting = new ProjectConfiguration(r, ProjectConfiguration.attributesFieldFormFields)
    return setting
  })
  return {
    data, count
  }
}

function convert_checklist_settings_to_table_schema({ "value": items, "@odata.count": count }) {
  const data = items.map(r => {
    const setting = new ProjectConfiguration(r, ProjectConfiguration.attributesChecklistFields)
    return setting
  })

  return {
    data, count
  }
}


function convert_fieldform_to_table_schema({ value }) {
  const data = value.map(r => {
    const setting = new ProjectConfiguration(r, ProjectConfiguration.attributesFieldFormFields)
    return setting
  })
  const count = value.length
  return {
    data, count
  }
}

async function getFieldFormSettings(page, per_page, orderByInfo, orderByDirection, search, filters) {

  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, [], orderByInfo, orderByDirection, filters
  );
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);

  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if (defaults.projectId) filter["ProjectId"] = { eq: { type: 'guid', value: defaults.projectId } };

  };
  const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(testfieldforms_configuration_endpoint, params);
  return convert_fieldform_settings_to_table_schema(data)
}

async function getChecklistSettings(page, per_page, orderByInfo, orderByDirection, search, filters) {
  console.log("sorting checklist")
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, [], orderByInfo, orderByDirection, filters
  );
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);
  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if (defaults.projectId) filter["ProjectId"] = { eq: { type: 'guid', value: defaults.projectId } };
  };

  const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  let data = await ApiRequest(checklist_configuration_endpoint, params);
  return convert_checklist_settings_to_table_schema(data)
}



async function getFieldForm({ projectId, isActive }) {
  const filter = { filter: { "ProjectId": { eq: { type: 'guid', value: projectId } } } };
  if (isActive) {
    filter.filter = { ...filter.filter, IsActive: isActive };
  };
  const params = buildQuery(filter);
  const data = await ApiRequest(testfieldforms_configuration_endpoint, params)
  return convert_fieldform_to_table_schema(data)
}

async function getSectionSettings(page, per_page, orderByInfo, orderByDirection, search) {
  const params = `?projectId=${search.projectID}`;
  const data = await ApiRequest(project_configuration_endpoint + '/YesNoQuestions', params)
  return convert_section_settings_to_table_schema(data)
}

async function getAdditionalFields(page, per_page, orderByInfo, orderByDirection, search) {
  const params = `?projectId=${search.projectID}`;
  const data = await ApiRequest(project_configuration_endpoint + '/AdditionalFields', params)
  const sectionsSettings = await ApiRequest(project_configuration_endpoint + '/YesNoQuestions', params)

  return convert_additional_settings_to_table_schema(data, sectionsSettings)
}

async function getReportSettings(projectID) {
  const params = `?projectId=${projectID}`;
  const data = await ApiRequest(project_configuration_endpoint + '/ReportSettings', params)
  const response = { data: [data] }
  return convert_report_settings_to_table_schema(response)
}

async function updateSectionSettings(data, projectID) {
  const params = `?projectId=${projectID}`;
  const resourcePath = `${project_configuration_endpoint}/YesNoQuestions`
  const result = await putItem(resourcePath, params, data, true)
  return result
}

async function updateAdditionalFields(data, projectID) {
  const params = `?projectId=${projectID}`;
  const resourcePath = `${project_configuration_endpoint}/AdditionalFields`
  const result = await putItem(resourcePath, params, data, true)
  return result
}

async function updateReportTemplate(projectID, data, defaultValues) {
  defaultValues.reportTemplateId = data.reportTemplateId
  const params = `?projectId=${projectID}`;
  const resourcePath = `${project_configuration_endpoint}/ReportSettings`
  const result = await putItem(resourcePath, params, defaultValues, true)
  return result
}

async function getDomainsForState(stateId) {
  const endpoint = `${project_configuration_endpoint}/WeatherStations`;
  const params = `?stateId=${stateId}`;
  const req = await ApiRequest(endpoint, params);
  return buildReference("/api/Domain?domainName=WeatherStation&includeReserved=false", req.data, 'weatherStationId', 'stationName');
}

async function addFieldForm(data) {
  const fieldFormsUploadPath = `${testfieldforms_configuration_endpoint}/Upload`
  const params = `?projectId=${data.ProjectId}&testtype=${data.TestType}&description=${data.Description}`;
  const result = await postItem(fieldFormsUploadPath, params, { value: data.value });
  console.log(result)
  return result;
};

async function addChecklistForm(files, data, projectID) {
  console.log(files)
  let results = []
  for (const arrayItem of files) {
    const found = data.find(({ path }) => path === arrayItem.path);
    if (found) {
      const fieldFormsUploadPath = `${checklist_configuration_endpoint}/Upload`
      const params = `?projectId=${projectID}&description=${found.description}&friendlyFileName=${found.name}`;

      const result = await postItem(fieldFormsUploadPath, params, { value: arrayItem });
      results.push(result)
    }
  }
  return results;
};

async function updateFieldForms(projectID, data, defaultValues) {
  defaultValues.Description = data.Description
  defaultValues.TestType = data.TestType
  defaultValues.IsActive = data.IsActive
  defaultValues.ProjectId = projectID
  // defaultValues.FormUid = data.FormUid
  const params = `?projectId=${projectID}`;
  const resourcePath = `${testfieldforms_configuration_endpoint}/Edit`
  const result = await putItem(resourcePath, params, defaultValues, true)
  return result
}

async function updateChecklistForms(projectID, data, defaultValues) {
  console.log(data)
  defaultValues.Description = data.Description
  // defaultValues.TestType = data.TestType
  defaultValues.IsActive = data.IsActive
  defaultValues.ProjectId = projectID
  //defaultValues.ChecklistFormId = data.ChecklistFormId
  const params = `?projectId=${projectID}`;
  const resourcePath = `${checklist_configuration_endpoint}/Edit`
  const result = await putItem(resourcePath, params, defaultValues, true)
  return result
}

async function deleteFieldForm(projectId, data) {
  const resourcePath = `${testfieldforms_configuration_endpoint}/Delete`;
  const params = `?id=${data.FormId}`;
  const result = await deleteItem(resourcePath, params);
  return result;
}

async function downloadChecklistForm(checkListId) {
  const resourcePath = `${checklist_configuration_endpoint}/download`;
  const params = `?CheckListId=${checkListId}`;
  const result = await ApiRequest(resourcePath, params);
  return result;
}

async function downloadTestFieldForm(fieldformid) {
  const resourcePath = `${testfieldforms_configuration_endpoint}/download`;
  const params = `?FormId=${fieldformid}`;
  const result = await ApiRequest(resourcePath, params);
  return result;
}

export {
  ProjectConfiguration, getSectionSettings, getAdditionalFields, updateSectionSettings, updateAdditionalFields,
  getReportSettings, updateReportTemplate, getDomainsForState, getFieldFormSettings, getFieldForm, addFieldForm, addChecklistForm,
  updateFieldForms, deleteFieldForm, getChecklistSettings, downloadChecklistForm, updateChecklistForms, downloadTestFieldForm
};